import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, takeUntil, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from 'ngx-toastr';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import * as i2$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import * as i1$1 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { getStepStatusUpdate, getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import * as moment from 'moment';
import { sync_profile_code } from 'permission-library';
import * as i5 from 'step-status-update-payload-service';

class ApiItineraryOfServicesLibraryService {
    constructor(http, toastrService) {
        this.http = http;
        this.toastrService = toastrService;
    }
    getBeneDetails(visaType, caseType, caseId, syncType, superTaskId, subTaskId) {
        return this.http.get(`/${visaType}/${caseType}/${caseId}/${syncType}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    getBeneExperienceInformation(visaType, caseType, caseId, syncType, superTaskId, subTaskId) {
        return this.http.get(`/${visaType}/${caseType}/${caseId}/${syncType}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            return response.data;
        }));
    }
    getJobDescriptionDetails(visaType, caseType, caseId, isThisPastJob) {
        return this.http.get(`/${visaType}/${caseType}/${caseId}/jobDescription?isThisPastJob=${isThisPastJob}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getJobDutyList(visaType, caseType, caseId, positionId) {
        return this.http.get(`/${visaType}/jobduty/${caseType}/${caseId}/position/${positionId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getIOSDetails(visaType, caseType, caseId) {
        return this.http.get(`/${visaType}/${caseType}/${caseId}/iosDetails`)
            .pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    saveIOSDetails(visaType, caseType, caseId, payload) {
        return this.http.post(`/${visaType}/${caseType}/${caseId}/iosDetails`, payload)
            .pipe(map((response) => {
            if (response.status === 200 && response.message) {
                this.toastrService.success(response.message, 'Success');
                return true;
            }
            else {
                return false;
            }
        }));
    }
}
ApiItineraryOfServicesLibraryService.ɵfac = function ApiItineraryOfServicesLibraryService_Factory(t) { return new (t || ApiItineraryOfServicesLibraryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ToastrService)); };
ApiItineraryOfServicesLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ApiItineraryOfServicesLibraryService, factory: ApiItineraryOfServicesLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiItineraryOfServicesLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ToastrService }]; }, null); })();

class BaseItineraryOfServicesLibraryService {
    constructor(guard, store, toastService, apiItineraryOfServicesLibraryService, stepStatusUpdatePayloadService) {
        this.guard = guard;
        this.store = store;
        this.toastService = toastService;
        this.apiItineraryOfServicesLibraryService = apiItineraryOfServicesLibraryService;
        this.stepStatusUpdatePayloadService = stepStatusUpdatePayloadService;
        this.observableSubscription$ = new Subject();
        this.resetForm = {
            jobDutyList: [{
                    jobDutyId: null,
                    educationDetails: [{
                            eduId: null,
                            courseId: null
                        }],
                    timeSpent: null,
                    workDetails: [{
                            workDetailId: null,
                            clientId: null
                        }]
                }]
        };
        this.educationList = [];
        this.experienceList = [];
        this.totalValue = 0;
    }
    loadInit() {
        this.itineraryOfServicesForm = new FormGroup({
            jobDutyList: new FormArray([])
        }, this.timeSpentValidation.bind(this));
        this.itineraryOfServicesForm.valueChanges.pipe(map(() => this.itineraryOfServicesForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.store.pipe(select(getStepStatusUpdate))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                // this.toastService.success(response.message);
            }
        });
        this.store.pipe(select(getStepDetails, { id: this.primaryData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
            this.stepDetails = data;
            this.modifiedDate = this.stepDetails.modifiedDate ? moment(new Date(this.stepDetails.modifiedDate)).format('MM/DD/YYYY') : null;
            this.disabledControls =
                this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW' ||
                    this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE' ||
                    this.stepDetails.stepStatusDetails.stepStatusCode === 'SUBMIT';
            if (this.disabledControls) {
                this.itineraryOfServicesForm.disable();
            }
            else {
                this.itineraryOfServicesForm.enable();
            }
            this.store.dispatch(new MarkCleanFormAction({
                dirty: false
            }));
        });
        combineLatest([
            this.apiItineraryOfServicesLibraryService.getBeneDetails(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.primaryData.superTaskId, this.primaryData.subTaskId),
            this.apiItineraryOfServicesLibraryService.getBeneExperienceInformation(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, 'EXPERIENCE', this.primaryData.superTaskId, this.primaryData.subTaskId),
            this.apiItineraryOfServicesLibraryService.getJobDescriptionDetails(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, false)
        ]).pipe(take(1))
            .subscribe((response) => {
            var _a, _b;
            const educationList = response[0].status === 200 ? response[0].data : [];
            this.educationList = [];
            educationList.forEach(x => {
                var _a;
                if (x.courses && x.courses.length > 0) {
                    x.courses.forEach((course) => {
                        var _a, _b;
                        this.educationList.push({
                            text: (course === null || course === void 0 ? void 0 : course.courseName) ? ((_a = x === null || x === void 0 ? void 0 : x.degreeType) === null || _a === void 0 ? void 0 : _a.name) + ' - ' + (course === null || course === void 0 ? void 0 : course.courseName) : (_b = x === null || x === void 0 ? void 0 : x.degreeType) === null || _b === void 0 ? void 0 : _b.name,
                            value: {
                                eduId: x === null || x === void 0 ? void 0 : x.id,
                                courseId: course === null || course === void 0 ? void 0 : course.courseId
                            }
                        });
                    });
                }
                else {
                    this.educationList.push({
                        text: (_a = x === null || x === void 0 ? void 0 : x.degreeType) === null || _a === void 0 ? void 0 : _a.name,
                        value: {
                            eduId: x === null || x === void 0 ? void 0 : x.id,
                            courseId: null
                        }
                    });
                }
            });
            const experienceList = response[1] ? response[1] : [];
            this.experienceList = [];
            experienceList.forEach(x => {
                if (x.clients && x.clients.length > 0) {
                    x.clients.map(client => {
                        this.experienceList.push({
                            text: (client === null || client === void 0 ? void 0 : client.clientName) ? (x === null || x === void 0 ? void 0 : x.companyName) + ' - ' + (client === null || client === void 0 ? void 0 : client.clientName) : x === null || x === void 0 ? void 0 : x.companyName,
                            value: {
                                workDetailId: x === null || x === void 0 ? void 0 : x.id,
                                id: client === null || client === void 0 ? void 0 : client.id,
                            }
                        });
                    });
                }
                else {
                    this.experienceList.push({
                        text: x === null || x === void 0 ? void 0 : x.companyName,
                        value: {
                            workDetailId: x === null || x === void 0 ? void 0 : x.id,
                            id: null,
                        }
                    });
                }
            });
            if (response[2]) {
                this.getListOfDuties((_b = (_a = response[2]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id);
            }
        });
    }
    timeSpentValidation(group) {
        if (!this.jobDutyList || (this.jobDutyList && this.jobDutyList.length === 0)) {
            return { noRecordsFound: true };
        }
        if ((!group.value.jobDutyList ||
            (group.value.jobDutyList && group.value.jobDutyList.length === 0)) ||
            group.value.jobDutyList.reduce((a, b) => a + parseInt(b.timeSpent ? b.timeSpent : '0'), 0) !== 100) {
            return { timeSpentNotEqualToHundred: true };
        }
        return null;
    }
    setTotalOnBLurOnInput() {
        this.setTotal(0, -1);
    }
    setTotal(newValue, index) {
        this.totalValue = this.itineraryOfServicesForm.value.jobDutyList.reduce((a, b, i) => {
            const currentValue = index === i ? newValue : parseInt(b.timeSpent ? b.timeSpent : '0');
            return a + currentValue;
        }, 0);
    }
    getListOfDuties(jobDescriptionId) {
        this.apiItineraryOfServicesLibraryService
            .getJobDutyList(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, jobDescriptionId)
            .pipe(take(1))
            .subscribe((response) => {
            if (response && response.data && response.data.length > 0) {
                this.jobDutyListTemp = response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { isCollapsed: true });
                });
                // this.jobDutyListTemp = [];
                this.jobDutyListTemp.forEach((jobDuty) => {
                    this.insertFormGroup(jobDuty.id);
                });
                this.getIOSDetails();
            }
        });
    }
    getIOSDetails() {
        this.apiItineraryOfServicesLibraryService.getIOSDetails(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId)
            .pipe(take(1))
            .subscribe(response => {
            this.setIOSDetails(response);
            this.setJobDutyList();
            this.setTotal(0, -1);
            this.itineraryOfServicesForm.reset(this.itineraryOfServicesForm.value);
        });
    }
    manuplateJobDutyList(item, index) {
        const rowValue = this.itineraryOfServicesForm.value.jobDutyList &&
            this.itineraryOfServicesForm.value.jobDutyList.length > 0 ?
            this.itineraryOfServicesForm.value.jobDutyList[index] : null;
        let educationDetailsText = '';
        if (rowValue && rowValue.educationDetails && rowValue.educationDetails.length > 0) {
            rowValue.educationDetails.forEach((x, i) => {
                educationDetailsText = i === 0 ? '' : educationDetailsText + ', ';
                educationDetailsText = educationDetailsText +
                    this.educationList.find(y => y.value.eduId === x.eduId &&
                        (x.courseId ? y.value.courseId === x.courseId : y.value.courseId === null)).text;
            });
        }
        let workDetailsText = '';
        if (rowValue && rowValue.workDetails && rowValue.workDetails.length > 0) {
            rowValue.workDetails.forEach((x, i) => {
                workDetailsText = i === 0 ? '' : workDetailsText + ', ';
                workDetailsText = workDetailsText +
                    this.experienceList.find(y => y.value.workDetailId === x.workDetailId &&
                        (x.id ? y.value.id === x.id : y.value.id === null)).text;
            });
        }
        return Object.assign(Object.assign({}, item), { isCollapsed: true, isEditable: !(rowValue &&
                ((rowValue.educationDetails && rowValue.educationDetails.length > 0) &&
                    (rowValue.workDetails && rowValue.workDetails.length > 0) &&
                    (rowValue.timeSpent))), educationDetailsText,
            workDetailsText });
    }
    setJobDutyList() {
        this.jobDutyList = this.jobDutyListTemp.map((item, index) => {
            return this.manuplateJobDutyList(item, index);
        });
    }
    onEditDone(index) {
        this.jobDutyList[index].isEditable = !this.jobDutyList[index].isEditable;
        if (!this.jobDutyList[index].isEditable) {
            this.jobDutyList[index] = this.manuplateJobDutyList(this.jobDutyList[index], index);
            this.setTotal(0, -1);
        }
    }
    setIOSDetails(response) {
        if (response && response.jobDutyList && response.jobDutyList.length > 0) {
            response.jobDutyList.forEach((jobDuty) => {
                const educationDetails = [];
                jobDuty.educationDetails.forEach((education) => {
                    if (education.courses && education.courses.length > 0) {
                        education.courses.filter((course) => course.selected)
                            .forEach((course) => {
                            educationDetails.push({
                                eduId: education.eduId,
                                courseId: course.courseId
                            });
                        });
                    }
                    else {
                        educationDetails.push({
                            eduId: education.eduId,
                            courseId: null
                        });
                    }
                });
                const workDetails = [];
                jobDuty.workDetails.forEach((workDetail) => {
                    if (workDetail.clients && workDetail.clients.length > 0) {
                        workDetail.clients.filter((client) => client.selected)
                            .forEach((client) => {
                            workDetails.push({
                                workDetailId: workDetail.workDetailId,
                                id: client.id
                            });
                        });
                    }
                    else {
                        workDetails.push({
                            workDetailId: workDetail.workDetailId,
                            id: null
                        });
                    }
                });
                this.itineraryOfServicesForm.get('jobDutyList')
                    .controls[this.jobDutyListTemp.findIndex(x => x.id === jobDuty.jobDutyId)].reset({
                    jobDutyId: jobDuty.jobDutyId,
                    educationDetails,
                    timeSpent: jobDuty.timeSpent,
                    workDetails
                });
            });
        }
    }
    insertFormGroup(jobDutyId) {
        this.itineraryOfServicesForm.get('jobDutyList').push(new FormGroup({
            jobDutyId: new FormControl(jobDutyId),
            educationDetails: new FormControl(null, Validators.required),
            timeSpent: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(100)]),
            workDetails: new FormControl(null, Validators.required)
        }));
    }
    get jobDutyListFormArray() {
        console.log('iiiiitttttt00', this.itineraryOfServicesForm.get('jobDutyList'));
        console.log('iiiiitttttt11', this.itineraryOfServicesForm.get('jobDutyList').controls);
        return this.itineraryOfServicesForm.get('jobDutyList').controls;
    }
    onSubmit() {
        const payload = [];
        this.itineraryOfServicesForm.value.jobDutyList.forEach(jobDuty => {
            const educationDetails = [];
            new Set(jobDuty.educationDetails.filter(x => x.eduId).map(x => x.eduId))
                .forEach(eduId => {
                const courses = jobDuty.educationDetails
                    .filter(x => x.eduId && x.courseId && x.eduId === eduId)
                    .map(x => {
                    return {
                        courseId: x.courseId
                    };
                });
                educationDetails.push({
                    courses,
                    eduId: String(eduId)
                });
            });
            const workDetails = [];
            new Set(jobDuty.workDetails.filter(x => x.workDetailId).map(x => x.workDetailId))
                .forEach(workDetailId => {
                const clients = jobDuty.workDetails
                    .filter(x => x.workDetailId && x.id && x.workDetailId === workDetailId)
                    .map(x => {
                    return {
                        id: String(x.id)
                    };
                });
                workDetails.push({
                    clients,
                    workDetailId: String(workDetailId)
                });
            });
            payload.push({
                educationDetails,
                jobDutyId: jobDuty.jobDutyId,
                timeSpent: String(jobDuty.timeSpent),
                workDetails
            });
        });
        this.apiItineraryOfServicesLibraryService.saveIOSDetails(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, payload)
            .pipe(take(1))
            .subscribe(response => {
            if (response) {
                if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                    this.updateStepStatus('INPROGRESS');
                }
                this.getIOSDetails();
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadService.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.primaryData.caseType === 'I130' ?
                this.primaryData.caseType : this.primaryData.visatype,
            stepId: this.primaryData.stepId
        }));
    }
    handleCancel() {
        this.getIOSDetails();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseItineraryOfServicesLibraryService.ɵfac = function BaseItineraryOfServicesLibraryService_Factory(t) { return new (t || BaseItineraryOfServicesLibraryService)(i0.ɵɵinject(i1$1.DirtyFormGuard), i0.ɵɵinject(i2$1.Store), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(ApiItineraryOfServicesLibraryService), i0.ɵɵinject(i5.StepStatusUpdatePayloadService)); };
BaseItineraryOfServicesLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseItineraryOfServicesLibraryService, factory: BaseItineraryOfServicesLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseItineraryOfServicesLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.DirtyFormGuard }, { type: i2$1.Store }, { type: i2.ToastrService }, { type: ApiItineraryOfServicesLibraryService }, { type: i5.StepStatusUpdatePayloadService }]; }, null); })();

/*
 * Public API Surface of base-itinerary-of-services-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiItineraryOfServicesLibraryService, BaseItineraryOfServicesLibraryService };
//# sourceMappingURL=base-itinerary-of-services-library.js.map
